module.exports = __webpack_public_path__ + "5e7f1712252bfbedbf5053331e74e6d8.MP3";